import 'bootstrap/dist/css/bootstrap.css';
import React from 'react';
import {BrowserRouter } from "react-router-dom"
//import ReactDom from 'react-dom';
import ReactDom from 'react-dom/client';
import App from './App';



const root = ReactDom.createRoot(document.getElementById("root"));

root.render(
    <React.StrictMode>
    <BrowserRouter>
            <App />
        </BrowserRouter>
    </React.StrictMode>
)


    